import React from 'react';
import './css/AppV2.css';

import SideMenu from './components/vers2/SideMenu';
import Footer from './components/vers2/Footer';
import HeroSection from './components/vers2/HeroSection';
import AboutSection from './components/vers2/AboutSection';
import MoreVisionSection from './components/vers2/MoreVisionSection';
import ActivitiesRatesSection from './components/vers2/ActivitiesRatesSection';
import IllnessSection from './components/vers2/IllnessSection';
import PickupContactSection from './components/vers2/PickupContactSection';
import ExchangeSection from './components/vers2/ExchangeSection';

/*
 * Koppel de logische paginanamen aan de id's van de secties op de pagina.
 * Zo kan het menu (en de "Lees meer" knop) naar de juiste sectie scrollen.
 */
const pageToSectionId: Record<string, string> = {
    home: 'home',
    about: 'over-mij',
    more: 'visie',
    daily: 'dagindeling',
    illness: 'ziekte',
    pickup: 'halen',
    contact: 'halen',
    exchange: 'ruildagen'
};

function AppV2() {
    /*
     * We houden dezelfde prop-signature (setPage) aan zodat de secties
     * niet aangepast hoeven te worden. In plaats van van "pagina" te
     * wisselen scrollen we nu netjes naar de bijbehorende sectie.
     */
    const goToSection: React.Dispatch<React.SetStateAction<string>> = (value) => {
        const key = typeof value === 'function' ? value('home') : value;
        const id = pageToSectionId[key] ?? key;
        const element = document.getElementById(id);

        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="App">
            <SideMenu setPage={goToSection} />
            <Footer />

            <HeroSection setPage={goToSection} />
            <AboutSection setPage={goToSection} />
            <MoreVisionSection setPage={goToSection} />
            <ActivitiesRatesSection setPage={goToSection} />
            <IllnessSection setPage={goToSection} />
            <PickupContactSection setPage={goToSection} />
            <ExchangeSection setPage={goToSection} />
        </div>
    );
}

export default AppV2;
